const common = {
  nav: {
    home: "Inicio",
    services: "Servicios",
    about: "Nosotros",
    testimonials: "Testimonios",
    contact: "Contacto",
    getQuote: "Solicitar Cotización",
  },
  footer: {
    tagline: "Tu hogar, nuestra prioridad.",
    services: "Servicios",
    company: "Empresa",
    contact: "Contacto",
    rights: "© 2026 Adry & Mich Cleaning and Handyman Service. Todos los derechos reservados.",
    privacy: "Privacidad",
    terms: "Términos",
    newsletter: "Recibe Ofertas Especiales",
    newsletterPlaceholder: "Tu correo electrónico",
    subscribe: "Suscribirse",
    schedule: "Lun – Sáb: 8:00 AM – 4:00 PM",
    payment: "Pago: Efectivo · Zelle · Cheque",
  },
  cta: {
    requestQuote: "Solicitar Cotización",
    whatsapp: "Escríbenos por WhatsApp",
    callNow: "Llamar Ahora",
    learnMore: "Saber Más",
    viewServices: "Ver Servicios",
    bookNow: "Reservar Ahora",
    sendMessage: "Enviar Mensaje",
    getStarted: "Comenzar",
  },
  contact: {
    phone: "(561) 262-6118",
    email: "adrimich7778@hotmail.com",
    address: "10639 Misty Lane, Royal Palm Beach, FL 33411",
  },
};

export default common;
